import { Component, OnInit, Input } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { ValidatorPasswordService } from "../../../components/password-validator/validator-password.service";
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.sass']
})
export class ChangePasswordComponent implements OnInit {

  public username:string;
  public newUserEmail:string;
  public defaultSubscriber:string;
  public actualPassword;
  public password1;
  public password2;
  public passwordConfirm;
  public requiredAccountUpdate;
  constructor(private services: Service,private global:GlobalService,private loadingScreenService :LoadingScreenService,private validatorPasswordService:ValidatorPasswordService) { }

  ngOnInit() {
    if(this.global.sessionReview()==true){
      this.username=JSON.parse(atob(sessionStorage.getItem("userName2")));
      this.defaultSubscriber=JSON.parse(atob(sessionStorage.getItem("defaultSubscriber")));
      this.requiredAccountUpdate=JSON.parse(atob(sessionStorage.getItem("requiredAccountUpdate")));
      this.newUserEmail='';
      this.actualPassword='';
      this.password1='';
      this.password2='';
    }
  }

  validateQuestion() {
            
    if (this.actualPassword === ''|| this.actualPassword === undefined) {
        this.global.notif("Debe colocar su la contraseña actual.");
        return false;
    }
    if (this.password1 === '' || this.password1 === undefined) {
        this.global.notif("Escriba su nueva contraseña.");
        return false;
    }
    if (this.password2 === '' || this.password2 === undefined) {
        this.global.notif("Debe confirmar la contraseña.");
        return false;
    }
    if (this.password1 !== this.password2) {
        this.global.notif("La contraseña actual no coincide con la confirmación.");
        return false;
    }
    else {
        this.passwordConfirm = this.password1;
    }
    return true;
  }
  continuePassword(){
      this.global.validateSession();
      if (this.validateQuestion()===true) {
          this.passwordConfirm = this.password1;
          this.loadingScreenService.startLoading();
          this.services.changePassword(sessionStorage.getItem("token"),this.actualPassword,this.passwordConfirm).subscribe(data =>{
            if(data.hasError ==false){
              this.loadingScreenService.stopLoading();
              this.passwordConfirm='';
              this.actualPassword='';
              this.password1='';
              this.password2='';
              this.global.notif("Su clave fue actualizada exitosamente.");
            }
            else{
              this.loadingScreenService.stopLoading();
              this.global.notif(data.errorDisplay);
            }
          });
      } 
      else {
          return;
      }

  }
  onKey(event: any){
    this.validatorPasswordService.onKey(event.target.value);
  }
  
}
